var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-circular',{class:_vm.classes,attrs:{"size":_vm.size,"width":_vm.width,"indeterminate":_vm.indeterminate,"color":_vm.color}})
}
var staticRenderFns = []

export { render, staticRenderFns }